import { useQuery } from "@tanstack/react-query";
import { getCurrentUserInfo, getUserInfoById } from "@/apis/auth.api";
import { UserInfoKey } from "@/constants";

const defaultAvatar =
  "https://gw.alipayobjects.com/zos/antfincdn/efFD%24IOql2/weixintupian_20170331104822.jpg";

// 获取当前登录用户的信息
export function useUserInfo() {
  const { data: res } = useQuery({
    queryKey: ["currentUserInfo"],
    queryFn: () => getCurrentUserInfo(),
  });

  const userInfo = JSON.stringify(res?.data.data || {});
  localStorage.setItem(UserInfoKey, userInfo);

  const { checkPassword, firstLogin } = res?.data.data || {};

  return {
    userInfo: res?.data.data,
    userId: res?.data.data.userId,
    avatar: res?.data.data.avatar || defaultAvatar,
    username: res?.data.data.username || "",
    nickName: res?.data.data.nickname || "",
    // 密码为 '123456' 且为首次登录时，需要修改密码
    shouldChangePassword: checkPassword === true && firstLogin === 0,
  };
}

// 根据用户id获取用户信息
export function useUserQuery(userId?: number | string) {
  const { data: res } = useQuery({
    queryKey: ["srmPurchaseUserInfo", userId],
    queryFn: () => getUserInfoById(userId!),
    enabled: !!userId,
  });

  return res?.data.data;
}

export function useUserFormFieldsQuery(userId?: number | string) {
  const createdUser = useUserQuery(userId);

  const loginUser = useUserInfo();

  if (createdUser) return createdUser;

  return loginUser.userInfo;
}
